import { render, staticRenderFns } from "./AteTestingCode.vue?vue&type=template&id=4814511e"
import script from "./AteTestingCode.vue?vue&type=script&lang=js"
export * from "./AteTestingCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports